import * as loaderActionTypes from './loaderActionTypes';

const loaderInitialState = {
  show: false,
};

const loaderReducer = (state = loaderInitialState, action) => {
  switch (action.type) {
    case loaderActionTypes.SHOW_LOADER:
      return {
        ...state,
        show: true,
      };

    case loaderActionTypes.HIDE_LOADER:
      return {
        ...state,
        show: false,
      };

    default:
      return state;
  }
};

export default loaderReducer;



// WEBPACK FOOTER //
// ./src/loader/loaderReducer.js